<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'Jobs' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to job list</span>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-card
          rounded="lg"
          outlined
          :style="'border-color: ' + maincolor">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="alertdata.show">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
              <v-col cols="12" md="12" v-if="loading.getdata" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.getdata && datalist.length > 0">
                <v-row>
                  <v-col cols="12" md="8">
                    <div class="d-flex">
                      <div class="d-inline mr-5">
                        <v-img
                          :lazy-src="require('../assets/default.jpg')"
                          :src="datalist[0].urlpic ? datalist[0].urlpic : ''"
                          max-height="70"
                          max-width="70">
                        </v-img>
                      </div>
                      <div class="d-inline">
                        <h2 class="text-md-h4 font-weight-bold">
                          {{ datalist[0].job_name ? datalist[0].job_name : 'Job Title' }}
                        </h2>
                        <span class="text-subtitle-1">
                          {{ datalist[0].com_name ? datalist[0].com_name : 'Company name' }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                    <v-chip
                      class="mb-0"
                      color="red darken-4"
                      small
                      dark>
                      <v-icon left small>
                        mdi-calendar-range
                      </v-icon>
                      {{ datalist[0].job_valid ? datalist[0].job_valid : 'Today' }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-btn
                      class="mr-3 mb-3 mb-md-0 white--text"
                      v-if="!isapply"
                      :loading="loading.apply"
                      :disabled="loading.apply"
                      depressed
                      large
                      :color="maincolor"
                      @click="applyJob(datalist[0].job_id)">
                      Apply to this job
                    </v-btn>
                    <v-btn
                      class="mr-3 mb-3 mb-md-0 white--text"
                      v-if="isapply"
                      :disabled="true"
                      depressed
                      large
                      :color="maincolor">
                      Applied
                    </v-btn>
                    <v-btn
                      class="mb-3 mb-md-0"
                      v-if="!issave"
                      :loading="loading.save"
                      :disabled="loading.save"
                      depressed
                      large
                      outlined
                      :color="maincolor"
                      @click="bookmarkJob(datalist[0].job_id)">
                      <v-icon left>
                        mdi-bookmark-outline
                      </v-icon>
                      Save It
                    </v-btn>
                    <v-btn
                      class="mb-3 mb-md-0"
                      v-if="issave"
                      :loading="loading.unsave"
                      :disabled="loading.unsave"
                      depressed
                      large
                      outlined
                      :color="maincolor"
                      @click="unsaveJob(datalist[0].job_id)">
                      <v-icon left>
                        mdi-bookmark
                      </v-icon>
                      Saved
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <span class="text-subtitle-1">Monthly salary range</span>
                    <h3 class="text-md-h6 font-weight-bold mb-3">
                      <v-icon :color="maincolor">
                        mdi-currency-usd
                      </v-icon>
                      {{ datalist[0].job_salary ? datalist[0].job_salary : 1 | rupiahformat }}
                    </h3>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span class="text-subtitle-1">Job Type</span>
                    <h3 class="text-md-h6 font-weight-bold mb-3">
                      <v-icon :color="maincolor">
                        mdi-account-hard-hat
                      </v-icon>
                      {{ datalist[0].job_type ? datalist[0].job_type : 'type' }}
                    </h3>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span class="text-subtitle-1">Specialization</span>
                    <h3 class="text-md-h6 font-weight-bold mb-3">
                      <v-icon :color="maincolor">
                        mdi-account-details-outline
                      </v-icon>
                      {{ datalist[0].job_special ? datalist[0].job_special : 'Specialization' }}
                    </h3>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span class="text-subtitle-1">Company size</span>
                    <h3 class="text-md-h6 font-weight-bold mb-3">
                      {{ datalist[0].com_size ? datalist[0].com_size : '2' }} employees
                    </h3>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span class="text-subtitle-1">Location</span>
                    <h3 class="text-md-h6 font-weight-bold mb-3">
                      {{ datalist[0].job_location ? datalist[0].job_location : 'Location' }}
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <h3 class="text-md-h5 font-weight-bold mb-3">
                      Job Description
                    </h3>
                    <div
                      class="content-editor"
                      v-html="datalist[0].job_desc ? datalist[0].job_desc : 'Description'">
                    </div>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-btn
                      v-if="!isapply"
                      :loading="loading.apply"
                      :disabled="loading.apply"
                      depressed
                      large
                      :color="maincolor"
                      @click="applyJob(datalist[0].job_id)"
                      class="white--text">
                      Apply to this job
                    </v-btn>
                    <v-btn
                      v-if="isapply"
                      :disabled="true"
                      depressed
                      large
                      :color="maincolor"
                      class="white--text">
                      Applied
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="appconfirm.modal"
      max-width="350">
      <v-card>
        <v-card-title class="headline">
          {{ appconfirm.title }}
        </v-card-title>
        <v-card-text>
          {{ appconfirm.text }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            :to="{ name: 'Register' }">
            Sign Up
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :to="{ name: 'Login' }">
            Log In
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';

export default {
  name: 'Jobdetail',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      apply: false,
      save: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    jobid: '',
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    isapply: false,
    issave: false,
    appconfirm: {
      modal: false,
      title: 'Apply for job',
      text: 'Only registered job seekers can apply the job, please Sign Up and Sign In as a jobseeker first. Thank you',
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjob',
      'usersjob',
    ]),
  },
  mounted() {
    if (this.$route.query.jobid && this.$route.query.jobid !== '') {
      this.jobid = this.$route.query.jobid;
      this.getDetailJob();
    }
  },
  watch: {
    '$route.query.jobid'(val) {
      if (val) {
        this.jobid = val;
        this.getDetailJob();
      }
    },
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    unsaveJob(jobid) {
      this.appconfirm.modal = false;
      if (this.tokenscr && this.userrole === 'jobseeker') {
        this.alertdata.show = true;
        this.loading.save = true;
        this.axios
          .post(
            this.api + '/api/jobs/unsave',
            qs.stringify({
              job_id: jobid,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.issave = false;
                this.$store.commit('REMOVE_JOBSAVE', resdata.data);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Job vacancies were successfully unsaved';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.save = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.save = false;
          });
      } else {
        this.appconfirm.modal = true;
        this.appconfirm.title = 'Save for job';
        this.appconfirm.text = 'Only registered job seekers can unsave the job, please Sign Up and Sign In as a jobseeker first. Thank you';
      }
    },
    bookmarkJob(jobid) {
      // console.log('Bookmark ' + jobid);
      this.appconfirm.modal = false;
      if (this.tokenscr && this.userrole === 'jobseeker') {
        this.alertdata.show = true;
        this.loading.save = true;
        this.axios
          .post(
            this.api + '/api/jobs/save',
            qs.stringify({
              job_id: jobid,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.issave = true;
                this.$store.commit('ADD_JOBSAVE', resdata.data);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Job vacancies were successfully saved';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.save = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.save = false;
          });
      } else {
        this.appconfirm.modal = true;
        this.appconfirm.title = 'Save for job';
        this.appconfirm.text = 'Only registered job seekers can save the job, please Sign Up and Sign In as a jobseeker first. Thank you';
      }
    },
    applyJob(jobid) {
      this.appconfirm.modal = false;
      if (this.tokenscr && this.userrole === 'jobseeker') {
        this.alertdata.show = true;
        this.loading.apply = true;
        this.axios
          .post(
            this.api + '/api/jobs/apply',
            qs.stringify({
              job_id: jobid,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.isapply = true;
                this.$store.commit('ADD_JOBAPP', resdata.data);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Job vacancies were successfully applied';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.apply = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.apply = false;
          });
      } else {
        this.appconfirm.modal = true;
        this.appconfirm.title = 'Apply for job';
        this.appconfirm.text = 'Only registered job seekers can apply the job, please Sign Up and Sign In as a jobseeker first. Thank you';
      }
    },
    getDetailJob() {
      this.alertdata.show = false;
      this.datalist = [];
      if (this.publickey) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/public/jobs/' + this.jobid,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.datalist.push(element);
                });
                this.isapply = this.userjob.includes(this.jobid);
                this.issave = this.usersjob.includes(this.jobid);
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Invalid Token!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
